import dynamic from "next/dynamic";
const TwoThirdsTextAndProductsHorizontalTabsComponent = dynamic(()=>import("./two-thirds-text-and-products-horizontal-tabs-component"));
import TwoThirdsTextAndProductsHorizontalTabsConfig from "./two-thirds-text-and-products-horizontal-tabs-config";
import TwoThirdsTextAndProductsHorizontalTabsAdvancedConfig from "./two-thirds-text-and-products-horizontal-tabs-advanced-config";
export default {
    TwoThirdsTextAndProductsHorizontalTabsComponent,
    TwoThirdsTextAndProductsHorizontalTabsConfig,
    TwoThirdsTextAndProductsHorizontalTabsAdvancedConfig
};
